export default __webpack_public_path__ + "static/myPhoto-0662f2b5f1871b338852ffd8e0e00de9.jpg";